// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";
import * as CustomComponentId$ApiTypes from "./CustomComponentId.bs.js";

function propValue_toJson(t) {
  if (typeof t === "number") {
    return Generic$ApiTypes.Encode.simpleVariant([[
                  "Unknown",
                  /* Unknown */0
                ]], /* Unknown */0);
  }
  switch (t.TAG | 0) {
    case /* String */0 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "String", Generic$ApiTypes.Encode.string);
    case /* Number */1 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "Number", Generic$ApiTypes.Encode.$$float);
    case /* Boolean */2 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "Boolean", Generic$ApiTypes.Encode.bool);
    
  }
}

var propValue_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("String", Generic$ApiTypes.Decode.string, (function (s) {
            return {
                    TAG: /* String */0,
                    _0: s
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Number", Generic$ApiTypes.Decode.$$float, (function (f) {
              return {
                      TAG: /* Number */1,
                      _0: f
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Boolean", Generic$ApiTypes.Decode.bool, (function (b) {
              return {
                      TAG: /* Boolean */2,
                      _0: b
                    };
            })),
      Generic$ApiTypes.Decode.simpleVariant([[
              "Unknown",
              /* Unknown */0
            ]])
    ]);

function reference_toJson(t) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "id",
                Curry._1(CustomComponentId$ApiTypes.toJson, t.id)
              ],
              [
                "name",
                Curry._1(Generic$ApiTypes.Encode.string, t.name)
              ],
              [
                "version",
                Curry._1(Generic$ApiTypes.Encode.string, t.version)
              ],
              [
                "componentUrl",
                Curry._1(Generic$ApiTypes.Encode.string, t.componentUrl)
              ],
              [
                "props",
                Generic$ApiTypes.Encode.dictWithEncoder(t.props, propValue_toJson)
              ]
            ]);
}

var reference_fromJson = Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (id, name, version, componentUrl, props) {
                            return {
                                    id: id,
                                    name: name,
                                    version: version,
                                    componentUrl: componentUrl,
                                    props: props
                                  };
                          })), Curry._2(Generic$ApiTypes.Decode.field, "id", CustomComponentId$ApiTypes.fromJson)), Curry._2(Generic$ApiTypes.Decode.field, "name", Generic$ApiTypes.Decode.string)), Curry._2(Generic$ApiTypes.Decode.field, "version", Generic$ApiTypes.Decode.string)), Curry._2(Generic$ApiTypes.Decode.field, "componentUrl", Generic$ApiTypes.Decode.string)), Generic$ApiTypes.Decode.fieldWithDefault("props", Curry._1(Generic$ApiTypes.Decode.dict, propValue_fromJson), {}));

export {
  propValue_toJson ,
  propValue_fromJson ,
  reference_toJson ,
  reference_fromJson ,
}
/* propValue_fromJson Not a pure module */
